export default __webpack_public_path__ + "static/media/welcome-advanced-tracking.64455eb6.png";